export default __webpack_public_path__ + "static/media/Montserrat-Regular.d7faa247.otf";